import { lighten, darken } from "./utils";
// const DEFAULT_COLOR = ["#31295F","#25577D", "#24FFFF"]

const DEFAULT_COLOR = "#24FFFF";

export const topicColors = {
	"internationale politik": "#CB4F83",
	"buergerrechte, gleichstellung, diskriminierung": "#E66CAE",
	"gedenken und erinnerung": "#72C9D5",
	weltanschauung: "#CD69E4",
	"klima, umwelt und energie": "#30D791",
	gesundheit: "#4692CA",
	"arbeits- und sozialpolitik": "#CE7A93",
	verkehr: "#C17777",
	bildung: "#D1C770",
	"stadtentwicklung und wohnen": "#A3B9CA",
	"parteipolitik und politische stroemungen": "#E69C66",
	"kinder und jugend": "#8459FF",
	kultur: "#5379FF",
	wirtschaft: "#67B2AC",
	sonstige: "#BDBDBD",
};

export const getTopicColor = (id) => {
	if (!id) return DEFAULT_COLOR;

	const trimmedId = id.split(" --- ")[0];
	return topicColors[trimmedId] || DEFAULT_COLOR;
};

export const getColorScale = (id) => {
	const baseColor = !!id ? getTopicColor(id) : DEFAULT_COLOR;

	return [
		darken(baseColor, 0.6),
		darken(baseColor, 0.4),
		darken(baseColor, 0.2),
		baseColor,
		lighten(baseColor, 0.2),
		lighten(baseColor, 0.4),
		lighten(baseColor, 0.6),
		lighten(baseColor, 0.8),
	];
};
